/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentReportQueryReportType extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentReportQueryReportType");
    }

    getFixupPrototypeFunction() { return AssessmentReportQueryReportType.fixupPrototype; }

    static newInstance(model: Partial<AssessmentReportQueryReportType>): AssessmentReportQueryReportType {
        let obj = Object.assign(new AssessmentReportQueryReportType(), model);
        AssessmentReportQueryReportType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentReportQueryReportType>): AssessmentReportQueryReportType {
        if (!model) return null;
        return AssessmentReportQueryReportType.newInstance(<AssessmentReportQueryReportType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentReportQueryReportType) {
        if (!obj) return;

        models.AssessmentReportQueryReportType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentReportQueryReportType): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentReportQueryReportType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Report type for assessment run
     */
    report_type: Array<models.WellArchitectedFrameworkAssessmentRunReportType>;

}
